import { render } from "./ReadingGoal.vue?vue&type=template&id=246fde70&scoped=true"
import script from "./ReadingGoal.vue?vue&type=script&lang=js"
export * from "./ReadingGoal.vue?vue&type=script&lang=js"

import "./ReadingGoal.vue?vue&type=style&index=0&id=246fde70&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246fde70"]])

export default __exports__